module.exports = __webpack_public_path__ + "img/dioxido.526c28ce.png";